import PropTypes from 'prop-types';

const recordShape = PropTypes.objectOf(
  PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool, PropTypes.array]),
);

export default recordShape;
